import HttpService from './HttpService';

export default class UserService extends HttpService {
    endPoint = "/v1/users"
}
